/** Compose a list of contour vertex arrays into a single SVG path
 *  `d` attribute. Each contour becomes one `M ... L ... Z`
 *  subpath. Used by the marquee renderer to build a fabric.Path
 *  with `fillRule: 'evenodd'` so masks with holes (e.g. an
 *  inverted selection, or a subject with interior background
 *  visible through a gap) render as topology-correct donuts
 *  rather than overlapping translucent fills.
 *
 *  Returns null when no contour has ≥3 vertices — fabric.Path
 *  with an empty / degenerate path errors at construction. */
export function contoursToSvgPath(contours: { x: number; y: number }[][]): string | null {
  const usable = contours.filter((c) => c.length >= 3);
  if (usable.length === 0) return null;
  const parts: string[] = [];
  for (const contour of usable) {
    parts.push(`M ${contour[0].x} ${contour[0].y}`);
    for (let i = 1; i < contour.length; i++) {
      parts.push(`L ${contour[i].x} ${contour[i].y}`);
    }
    parts.push('Z');
  }
  return parts.join(' ');
}
